import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const PublicNavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const links = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/core-solutions', label: 'Core Solutions' },
    { path: '/products', label: 'Products' },
    { path: '/news', label: 'News' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <>
      <header className="public-nav">
        <div className="public-nav-inner">
          <div className="public-nav-header">
            <NavLink to="/" className="public-brand" onClick={() => setMenuOpen(false)}>
              <img className="brand-logo" src="/logoMain.png" alt="Trelledex logo" />
              <img
                className="brand-wordmark"
                src="/company-name.png"
                alt="Trelledex"
              />
            </NavLink>
            <button
              type="button"
              className="nav-toggle"
              aria-expanded={menuOpen}
              aria-controls="public-nav-links"
              onClick={() => setMenuOpen((open) => !open)}
            >
              Menu
            </button>
          </div>
          <nav id="public-nav-links" className={`public-links ${menuOpen ? 'is-open' : ''}`}>
            {links.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  isActive ? 'public-link active' : 'public-link'
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <div className={`public-actions ${menuOpen ? 'is-open' : ''}`}>
            <button type="button" className="public-login" onClick={() => { setMenuOpen(false); navigate('/login'); }}>
              Login
            </button>
            <button type="button" className="btn btn-primary nav-cta" onClick={() => { setMenuOpen(false); navigate('/register'); }}>
              Register
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default PublicNavBar;
